import { create } from 'zustand'
import { ru, type Dict } from './ru'
import { en } from './en'

export type Locale = 'ru' | 'en'
export const DICTS: Record<Locale, Dict> = { ru, en }

const KEY = 'linia_locale'

function detect(): Locale {
  const saved = localStorage.getItem(KEY)
  if (saved === 'ru' || saved === 'en') return saved
  const nav = navigator.languages?.join(',') || navigator.language || ''
  // Кириллические локали идут на RU: первый рынок — RU-аудитория нейрографики.
  return /\b(ru|be|uk|kk|ky|uz)\b/i.test(nav) ? 'ru' : 'en'
}

type I18nStore = {
  locale: Locale
  t: Dict
  setLocale: (l: Locale) => void
}

export const useI18n = create<I18nStore>((set) => {
  const locale = detect()
  document.documentElement.lang = locale
  return {
    locale,
    t: DICTS[locale],
    setLocale: (l) => {
      localStorage.setItem(KEY, l)
      document.documentElement.lang = l
      set({ locale: l, t: DICTS[l] })
    },
  }
})

/** Локаль вне React-дерева (для api-слоя и промптов). */
export const currentLocale = (): Locale => useI18n.getState().locale
export const tr = (): Dict => useI18n.getState().t
